export enum OrderStatus {
  CREATED = "CREATED",
  ERROR = "ERROR",
  SHIPPED = "SHIPPED",
  DELIVERED = "DELIVERED",
  CANCELLED = "CANCELLED",
}
